import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { ReactElement, useState } from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type SVTabsProps = {
  headers: string[];
  panels: ReactElement[];
};

export default function SVTabs({ headers, panels }: SVTabsProps) {
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example">
          {headers.map((header, index) => {
            return (
              <Tab
                sx={{ fontWeight: 'bold' }}
                key={header}
                label={header}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </Box>
      {panels.map((panel, index) => {
        return (
          <CustomTabPanel key={index} value={value} index={index}>
            {panel}
          </CustomTabPanel>
        );
      })}
    </Box>
  );
}
